import React from "react";

const ThingsToKnowSkeleton: React.FC = () => {
  return (
    <div className="listingSection__wrap animate-pulse space-y-4">
      {/* Heading */}
      <div className="w-32 h-8 bg-gray-300 rounded-md"></div>
      <div className="w-14 h-px bg-neutral-200 dark:bg-neutral-700" />

      {/* Content Skeleton */}
      <div className="space-y-3">
        <div className="w-24 h-6 bg-gray-300 rounded-md"></div>
        <div className="mt-3 space-y-3 max-w-md">
          <div className="flex justify-between p-3 bg-neutral-100 dark:bg-neutral-800 rounded-lg">
            <div className="w-20 h-4 bg-gray-300 rounded-md"></div>
            <div className="w-16 h-4 bg-gray-300 rounded-md"></div>
          </div>
          <div className="flex justify-between p-3">
            <div className="w-20 h-4 bg-gray-300 rounded-md"></div>
            <div className="w-16 h-4 bg-gray-300 rounded-md"></div>
          </div>
        </div>
      </div>
      <div className="w-14 h-px bg-neutral-200 dark:bg-neutral-700" />
    </div>
  );
};

export default ThingsToKnowSkeleton;